import { useCallback, useRef } from "react";

import useActivityTracker from "hooks/useActivityTracker";
import useAuthentication from "hooks/useAuthentication";
import { setUiVersionCookie } from "utils/setUiVersionCookie";

export const PLATFORM_SWITCH_BANNER_HEIGHT = 40;
export const PLATFORM_SWITCH_BANNER_DISMISSED_KEY =
  "sk-platform-switch-banner-dismissed";

const ACTIVITY_WAIT_MS = 3000;

const usePlatformSwitchBanner = () => {
  const { authenticated, account } = useAuthentication();
  const { trackActivity } = useActivityTracker();

  const canSwitchPlatform = !!account?.canSwitchPlatform;

  // Guards against a second click while the activity is still in flight.
  const switching = useRef(false);

  const switchToNewUi = useCallback(async () => {
    if (!account?.id || switching.current) return;
    switching.current = true;

    await Promise.race([
      trackActivity(
        "account.switch_platform",
        { type: "accounts", id: account?.id },
        { target: "new" }
      ),
      new Promise((resolve) => setTimeout(resolve, ACTIVITY_WAIT_MS)),
    ]);

    setUiVersionCookie("new");
    window.location.href = "/login";
  }, [trackActivity, account?.id]);

  return {
    visible: authenticated && canSwitchPlatform,
    switchToNewUi,
  };
};

export default usePlatformSwitchBanner;
